export default __webpack_public_path__ + "static/media/small-logo.880eb778.svg";